import React from "react";
import StaffOverview from "./StaffOverview";
import StaffDepartments from "./StaffDepartments";
import QuickActions from "./QuickActions";

import StaffTabs from "./StaffTabs";
import { LuUserPlus } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function StaffMain() {
  const navigate=useNavigate();
  return (
    <div
      className="container-fluid"
      style={{ width: "100%", padding: "0px", background: "#f8f9fb" }}
    >
      <div className="mb-4">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div>
        <h1 style={{ fontSize: "1.7rem", marginBottom: "3px" }}>
          Staff Management
        </h1>
        <p style={{ color: "#888", marginTop: 0 }}>
          Manage clinic staff, roles, and permissions
        </p>
        </div>
        <div className="me-2"><button onClick={()=>navigate("/StaffAdd")} className="gradient-button w-100" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><LuUserPlus style={{marginRight:5}}/>Add New Staff</button></div>
        </div>
      </div>

      {/* Row with 2 columns */}
      <div className="row">
        {/* Left Column - col-9 */}
        <div className="col-12 col-md-9 col-lg-9 border-1 rounded-lg bg-white">
          <StaffTabs />
        </div>

        {/* Right Column - col-3 */}
        <div className="col-12 col-md-3 col-lg-3 d-flex flex-column gap-3">
          <div className="rounded-lg shadow-md hover:bg-gray-100 hover:shadow-lg cursor-pointer transition-all duration-300">
            <StaffOverview />
          </div>
          <div className="rounded-lg shadow-md hover:bg-gray-100 hover:shadow-lg cursor-pointer transition-all duration-300">
            <StaffDepartments />
          </div>
          <div className="rounded-lg shadow-md hover:bg-gray-100 hover:shadow-lg cursor-pointer transition-all duration-300">
            <QuickActions />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaffMain;
